/**
 * Fire Results — Interactivity API view module.
 *
 * Connects to the shared store defined by fire-filters.
 * The store() call ensures the namespace is registered even if
 * this block's script loads before the filters block.
 */

import { store } from "@wordpress/interactivity";

// Reference the same store namespace.
// The fire-filters block defines the full state and actions;
// calling store() here with an empty config just ensures the
// namespace is available and merges gracefully.
store("byggma-brann-og-lyd/fire", {});
